/**
 * @generated SignedSource<<6c402acb871860115d89f8637f06f0c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type Inconveniences = "External" | "MissedLunch" | "NoMeetingRelief" | "OnNoMeetingDay" | "Other" | "OutsideMeetingHours" | "OutsideWorkingHours" | "Uncrawled" | "%future added value";
export type Unavailabilities = "FarOutsideWorkingHours" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventPeople_org$data = {
  readonly id: string;
  readonly experiments: ReadonlyArray<string | null> | null;
  readonly computeCurrentSlotImpactErrorable: {
    readonly __typename: "GraphEntityError";
    readonly statusCode: number | null;
    readonly message: string | null;
  } | {
    readonly __typename: "CurrentScheduledSlotImpact";
    readonly currentSlot: {
      readonly summary: {
        readonly conflictingAttendees: ReadonlyArray<string>;
        readonly unavailableAttendees: ReadonlyArray<string>;
        readonly inconvenientForAttendees: ReadonlyArray<string>;
        readonly focusTimeMinutesCost: number;
      };
      readonly attendanceImpacts: ReadonlyArray<{
        readonly hasConflict: boolean;
        readonly calendarId: string;
        readonly focusTimeMinutesCost: number;
        readonly inconveniences: ReadonlyArray<Inconveniences>;
        readonly unavailabilities: ReadonlyArray<Unavailabilities>;
        readonly conflictingMeetings: ReadonlyArray<string>;
      }>;
    } | null;
    readonly uncrawledCalendars: ReadonlyArray<string | null>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "EventPeople_org";
};
export type EventPeople_org$key = {
  readonly " $data"?: EventPeople_org$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventPeople_org">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "focusTimeMinutesCost",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "externalEventId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventPeople_org",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "experiments",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "externalEventId",
          "variableName": "externalEventId"
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "computeCurrentSlotImpactErrorable",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "statusCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "message",
              "storageKey": null
            }
          ],
          "type": "GraphEntityError",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SchedulingSlot",
              "kind": "LinkedField",
              "name": "currentSlot",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SchedulingAttendanceSummary",
                  "kind": "LinkedField",
                  "name": "summary",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conflictingAttendees",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unavailableAttendees",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inconvenientForAttendees",
                      "storageKey": null
                    },
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SchedulingAttendanceImpact",
                  "kind": "LinkedField",
                  "name": "attendanceImpacts",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasConflict",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "calendarId",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "inconveniences",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "unavailabilities",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "conflictingMeetings",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "uncrawledCalendars",
              "storageKey": null
            }
          ],
          "type": "CurrentScheduledSlotImpact",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Org",
  "abstractKey": null
};
})();

(node as any).hash = "cc8b559f9f7ccc251635ec94bc05b526";

export default node;
